import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-row flex-root position-absolute min-w-100 min-h-100" }
const _hoisted_2 = { class: "mo-registration-cover" }
const _hoisted_3 = { class: "mo-sticky-wrapper" }
const _hoisted_4 = { class: "mo-cover-logo" }
const _hoisted_5 = { href: "https://multiorders.com" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"headline\"><div class=\"mo-title anime-slide-left#small anime-delay#1\"> Create Your <span class=\"accent\">First<br> Software Managment</span><br><span class=\"mo-title-next-liner\">Account</span></div><div class=\"\n                            mo-description\n                            anime-slide-right#small anime-delay#2\n                        \"> Start Your <span class=\"accent\">14-Day</span> Trial<br><span class=\"fw-lighter fs-5\">No Credit Card Required</span></div></div><div class=\"copyright\"> Multiorders 2021 © All rights reserved </div>", 2)
const _hoisted_9 = { class: "\n                login-view\n                d-flex\n                flex-center flex-column flex-column-fluid\n                p-sm-10\n            " }
const _hoisted_10 = { class: "\n                    login-block\n                    w-lg-500px\n                    bg-white\n                    rounded\n                    p-10 p-lg-15\n                    mx-auto\n                " }
const _hoisted_11 = { class: "text-center mb-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 fs-1" }, "Account Creation", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 mb-3 fs-4 mt-5" }, [
  /*#__PURE__*/_createTextVNode(" Already have an account "),
  /*#__PURE__*/_createElementVNode("span", { class: "link-primary fw-bolder" }, "Log in")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "anime-slide-left#xsmall"
}
const _hoisted_15 = { class: "text-danger" }
const _hoisted_16 = { class: "row fv-row mb-6" }
const _hoisted_17 = { class: "col-xl-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Name", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-xl-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Surname", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "d-flex flex-column mb-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Country", -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row fv-row mb-12" }
const _hoisted_35 = { class: "col-xl-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Phone Number", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "col-xl-8 position-relative" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "\n                                    form-label\n                                    fw-bolder\n                                    text-dark\n                                    fs-6\n                                    opacity#0\n                                " }, "Placeholder", -1)
const _hoisted_40 = { class: "mo-phone-dial-code" }
const _hoisted_41 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = {
  id: "kt-password-meter",
  class: "mb-6 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_44 = { class: "mb-1" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, " Password ", -1)
const _hoisted_46 = { class: "position-relative mb-3" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt-password-meter-highlight",
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "\n                                    flex-grow-1\n                                    bg-secondary bg-active-success\n                                    rounded\n                                    h-5px\n                                    me-2\n                                " }),
  /*#__PURE__*/_createElementVNode("div", { class: "\n                                    flex-grow-1\n                                    bg-secondary bg-active-success\n                                    rounded\n                                    h-5px\n                                    me-2\n                                " }),
  /*#__PURE__*/_createElementVNode("div", { class: "\n                                    flex-grow-1\n                                    bg-secondary bg-active-success\n                                    rounded\n                                    h-5px\n                                    me-2\n                                " }),
  /*#__PURE__*/_createElementVNode("div", { class: "\n                                    flex-grow-1\n                                    bg-secondary bg-active-success\n                                    rounded\n                                    h-5px\n                                " })
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Use 5 or more characters with a mix of letters, numbers & symbols. ", -1)
const _hoisted_51 = { class: "fv-row mb-12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Confirm Password", -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "mb-12" }
const _hoisted_56 = { class: "d-flex flex-stack" }
const _hoisted_57 = { class: "\n                                    form-check\n                                    form-check-custom\n                                    form-check-solid\n                                " }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  for: "terms",
  class: "form-check-label ml-10"
}, [
  /*#__PURE__*/_createTextVNode(" By creating an account, you agree to the Multiorders "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://multiorders.com/terms-of-service/",
    target: "_blank"
  }, "Terms of Service")
], -1)
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "text-center" }
const _hoisted_62 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Create ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "\n                                        spinner-border spinner-border-sm\n                                        align-middle\n                                        ms-2\n                                    " })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("img", {
              alt: "Logo",
              src: _ctx.originUrl + _ctx.logo
            }, null, 8, _hoisted_6)
          ])
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.registrationScheme
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_router_link, { to: "/auth/login" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            (_ctx.messagesError.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messagesError, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message,
                      class: "mb-10 bg-light-danger p-8 rounded"
                    }, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(message), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  class: "\n                                    form-control\n                                    form-control-lg\n                                    form-control-solid\n                                ",
                  type: "text",
                  placeholder: "",
                  name: "name",
                  modelValue: _ctx.registrationDetails.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.registrationDetails.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_ErrorMessage, {
                      name: "name",
                      class: "anime-slide-left#xsmall d-block"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, {
                  class: "\n                                    form-control\n                                    form-control-lg\n                                    form-control-solid\n                                ",
                  type: "text",
                  placeholder: "",
                  name: "surname",
                  modelValue: _ctx.registrationDetails.surname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.registrationDetails.surname = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_ErrorMessage, {
                      name: "surname",
                      class: "anime-slide-left#xsmall d-block"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                class: "\n                                form-control form-control-lg form-control-solid\n                            ",
                type: "text",
                name: "email",
                modelValue: _ctx.registrationDetails.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.registrationDetails.email = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_ErrorMessage, {
                    name: "email",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_Field, {
                name: "country",
                class: "form-select form-select-solid",
                modelValue: _ctx.registrationDetails.country,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.registrationDetails.country = $event)),
                as: "select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: country
                    }, _toDisplayString(country), 9, _hoisted_31))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_ErrorMessage, {
                    name: "country",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_Field, {
                  name: "phoneCountry",
                  class: "form-select form-select-solid",
                  modelValue: _ctx.registrationDetails.phoneCountryCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.registrationDetails.phoneCountryCode = $event)),
                  onChange: _ctx.onChangePhoneDialCode,
                  as: "select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesPhonePrefix, (country, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: country.code
                      }, _toDisplayString(country.name) + " " + _toDisplayString(country.dial_code), 9, _hoisted_37))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.registrationDetails.phoneDialCode), 1),
                _createVNode(_component_Field, {
                  class: "\n                                    form-control\n                                    form-control-lg\n                                    form-control-solid\n                                ",
                  type: "text",
                  placeholder: "",
                  name: "phoneNumber",
                  modelValue: _ctx.registrationDetails.phoneNumber,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.registrationDetails.phoneNumber = $event)),
                  autocomplete: "off",
                  onKeypress: _ctx.onKeyDownPhoneNumber,
                  style: _normalizeStyle({
                                    'padding-left': `${
                                        _ctx.registrationDetails.phoneDialCodeLength *
                                            10 +
                                        30
                                    }px`,
                                })
                }, null, 8, ["modelValue", "onKeypress", "style"])
              ]),
              _createVNode(_component_Field, {
                class: "d-none",
                type: "text",
                placeholder: "",
                name: "phoneNumberWithDialCode",
                modelValue: _ctx.phoneNumberWithDialCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phoneNumberWithDialCode = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"]),
              (_ctx.registrationDetails.phoneNumberValidation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_ErrorMessage, {
                        name: "phoneNumberWithDialCode",
                        class: "anime-slide-left#xsmall d-block"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_Field, {
                    class: "\n                                        form-control\n                                        form-control-lg\n                                        form-control-solid\n                                    ",
                    type: "password",
                    placeholder: "",
                    name: "password",
                    modelValue: _ctx.registrationDetails.password,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.registrationDetails.password = $event)),
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_ErrorMessage, {
                      name: "password",
                      class: "anime-slide-left#xsmall d-block"
                    })
                  ])
                ])
              ]),
              _hoisted_49,
              _hoisted_50
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createVNode(_component_Field, {
                class: "\n                                form-control form-control-lg form-control-solid\n                            ",
                type: "password",
                placeholder: "",
                name: "passwordConfirm",
                modelValue: _ctx.registrationDetails.passwordConfirm,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.registrationDetails.passwordConfirm = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_ErrorMessage, {
                    name: "passwordConfirm",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_Field, {
                    id: "terms",
                    type: "checkbox",
                    name: "terms",
                    modelValue: _ctx.registrationDetails.terms,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.registrationDetails.terms = $event)),
                    className: "form-check-input"
                  }, null, 8, ["modelValue"]),
                  _hoisted_58
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_ErrorMessage, {
                    name: "terms",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", _hoisted_62, _hoisted_65, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}